module.exports = __webpack_public_path__ + "img/Door_Open.cd485dcc.png";